import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

const AdminSettingFormModal = ({
  open,
  handleClose,
  settingData,
  handleInputChange,
  handleSubmit,
  isEditing,
}) => {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isEditing ? "Edit Admin Setting" : "Add New Admin Setting"}
      </DialogTitle>
      <DialogContent dividers>
        {/* <TextField
          fullWidth
          label="Key"
          name="key"
          value={settingData.key}
          onChange={handleInputChange}
          margin="normal"
        /> */}
        <TextField
          fullWidth
          label="Value"
          name="value"
          value={settingData.value}
          onChange={handleInputChange}
          margin="normal"
        />
        <TextField
          fullWidth
          label="Description"
          name="description"
          value={settingData.description}
          onChange={handleInputChange}
          margin="normal"
        />
        {/* <FormControlLabel
          control={
            <Switch
              checked={settingData.status === "active"}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "status",
                    value: e.target.checked ? "active" : "inactive",
                  },
                })
              }
              color="primary"
            />
          }
          label="Active"
        /> */}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          {isEditing ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdminSettingFormModal;
